import React from "react";
import { Carousel, Col, Container, Image, Row } from "react-bootstrap";
import Pearl from "../img/pearl.webp";
import Tama from "../img/tama.webp";
import Yamaha from "../img/yamaha.webp";
import Zildjian from "../img/zildjian.webp";

export const BrandsIUse = () => {
  return (
    <Container fluid as="section" className="brands-section" data-aos="fade-in">
      <Container>
        <Row>
          <Col>
            <hr />
            <h2>Brands I Use</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <Carousel>
              <Carousel.Item>
                <Image
                  fluid
                  className="d-block w-50 margin-left-right-auto"
                  src={Pearl}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  fluid
                  className="d-block w-50 margin-left-right-auto"
                  src={Tama}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  fluid
                  width="200px"
                  height="200px"
                  className="d-block w-50 margin-left-right-auto"
                  src={Yamaha}
                  alt="Third slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <Image
                  fluid
                  className="d-block w-50 margin-left-right-auto"
                  src={Zildjian}
                  alt="Fourth slide"
                />
              </Carousel.Item>
            </Carousel>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <div class="embed-responsive embed-responsive-16by9 mt-5">
              <iframe
                data-aos="fade-in"
                title="Youtube Video Playthorugh"
                class="embed-responsive-item"
                src="https://www.youtube.com/embed/Hkjo-iwMJWU"
                allowfullscreen
              ></iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
